import { useState } from 'react';
import { TaskPage } from '../../../components/workbook/TaskPage';
import { TextArea } from '../../../components/workbook/forms';
import { Callout } from '../../../components/workbook/Callout';

export default function PlayItOutPrioritizePage() {
  const [marketplace, setMarketplace] = useState('');
  const [tradeOffStory, setTradeOffStory] = useState('');
  const [reflections, setReflections] = useState('');

  return (
    <TaskPage
      phase="prioritize"
      title="Play It Out (Commitment Marketplace)"
      pageNumber={7}
      instruction="Run a quick commitment marketplace. Each owner posts their slice card; teammates 'shop' for where to help (skill or unblock). Mark co-owners and 'help windows.' Story (pairs): explain one trade-off you accepted to protect a slice. Reflect (team): what did we remove or defer to keep capacity honest?"
      whyItMatters="The build → story → reflect cycle boosts engagement, reduces stress, and makes commitments memorable."
      coachRail={{
        timing: "10-15 minutes",
        tips: "Use physical or digital cards. Each owner posts their slice; others 'shop' for ways to help.",
        debrief: "What did we remove or defer? Are commitments clear?"
      }}
    >
      <div className="space-y-6">
        <div className="bg-[var(--surface)] p-6">
          <h3 className="text-lg font-semibold text-[var(--text-pri)] mb-4">Build: Commitment Marketplace</h3>
          <p className="text-sm text-[var(--text-sec)] mb-4">Each owner posts their slice card; teammates 'shop' for where to help (skill or unblock). Mark co-owners and 'help windows.'</p>
          <TextArea
            label="Marketplace notes"
            value={marketplace}
            onChange={(e) => setMarketplace(e.target.value)}
            placeholder="Who owns what? Who's helping where? What co-ownership and help windows were identified?"
            rows={6}
          />
        </div>

        <div className="bg-[var(--slate-dim)] border border-[var(--slate)] p-6">
          <h3 className="text-lg font-semibold text-[var(--text-sec)] mb-4">Story: Trade-off (Pairs)</h3>
          <p className="text-sm text-[var(--text-sec)] mb-4">Explain one trade-off you accepted to protect a slice.</p>
          <TextArea
            label="Trade-off story"
            value={tradeOffStory}
            onChange={(e) => setTradeOffStory(e.target.value)}
            placeholder="What trade-off did you accept? What did you give up to protect this slice?"
            rows={5}
          />
        </div>

        <div className="bg-[var(--green-dim)] border border-[var(--green)] p-6">
          <h3 className="text-lg font-semibold text-[var(--green)] dark:text-[var(--text-ter)] mb-4">Reflect: Capacity Honesty (Team)</h3>
          <p className="text-sm text-[var(--green)] dark:text-[var(--text-ter)] mb-4">What did we remove or defer to keep capacity honest?</p>
          <TextArea
            label="Reflection notes"
            value={reflections}
            onChange={(e) => setReflections(e.target.value)}
            placeholder="What did we cut or defer? Are commitments realistic? What trade-offs did we make?"
            rows={5}
          />
        </div>

        <Callout type="tip" phase="prioritize">
          <p className="text-sm">This exercise helps surface dependencies, identify help opportunities, and make commitments visible and memorable.</p>
        </Callout>
      </div>
    </TaskPage>
  );
}

